// extracted by mini-css-extract-plugin
export default {"main":"CircleText_main__mBTv6","img1":"CircleText_img1__FWSCi","img2":"CircleText_img2__-RLHG"};